import { render, staticRenderFns } from "./AfterSalesReturnPage.vue?vue&type=template&id=507c1f2e&scoped=true"
import script from "./AfterSalesReturnPage.vue?vue&type=script&lang=js"
export * from "./AfterSalesReturnPage.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesReturnPage.vue?vue&type=style&index=0&id=507c1f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c1f2e",
  null
  
)

export default component.exports